import { render, staticRenderFns } from "./paymentRequestDetail.vue?vue&type=template&id=6dda3d6d&scoped=true"
import script from "./paymentRequestDetail.vue?vue&type=script&lang=js"
export * from "./paymentRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./paymentRequestDetail.vue?vue&type=style&index=0&id=6dda3d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda3d6d",
  null
  
)

export default component.exports